export default {
  statisticalAnalysis: {
    btnList: {
      add: '增加',
      del: '删除',
      save: '保存',
    },
    table: {
      businessDepartmentNo: '事业部编码',
      businessDepartmentDesc: '事业部名称',
      businessDepartmentDescPlaceholder: '请选择事业部名称',
      partnerType: '合作伙伴类型',
      partnerTypeNamePlaceholder: '请选择合作伙伴类型',
      partnerNo: '合作伙伴编码',
      partnerNoPlaceholder: '请选择合作伙伴编码',
      partnerName: '合作伙伴名称',
      partnerNamePlaceholder: '请选择合作伙伴名称',
      creditLevel: '信用级别',
      creditLevelPlaceholder: '请选择信用级别',
      registDate: '成立日期',
      registDatePlaceholder: '请选择成立日期',
      registAsset: '注册资本',
      registAssetPlaceholder: '请输入注册资本',
      creditAccount: '信用账户号',
      creditAccountPlaceholder: '请输入信用账户号',
      creditAccountDesc: '信用账户号描述',
      creditAccountDescPlaceholder: '请输入信用账户号描述',
      validStart: '有效期从',
      validStartPlaceholder: '请选择有效期开始日期',
      validEnd: '有效期到',
      validEndPlaceholder: '请选择有效期结束日期',
      minQuantity: '单边交易上限（低）',
      minQuantityPlaceholder: '请输入单边交易上限（低）',
      maxQuantity: '单边交易上限（高）',
      maxQuantityPlaceholder: '请输入单边交易上限（高）',
      quantityUnit: '单位',
      quantityUnitPlaceholder: '请选择单位',
      mark: '备注',
    },
    tips: {
      partnerTypePlaceholder: '请先选择合作伙伴类型',
      noSelect: '您还没选择要删除的数据',
      noData: '当前数据列表不能为空！',
    },
  },
};
